import { type WorldCollider } from '@/world/zone';

export const slideAgainstTrees = (
  trees: ReadonlyArray<WorldCollider>,
  fromX: number,
  fromZ: number,
  toX: number,
  toZ: number,
  radius: number,
): [number, number] => {
  let x = toX;
  let z = toZ;
  for (let i = 0; i < trees.length; i++) {
    const t = trees[i]!;
    const dx = x - t.x;
    const dz = z - t.z;
    const minDist = t.radius + radius;
    const distSq = dx * dx + dz * dz;
    if (distSq >= minDist * minDist) continue;
    const d = Math.sqrt(distSq);
    if (d < 1e-5) {
      x = fromX;
      z = fromZ;
      continue;
    }
    const inv = 1 / d;
    x = t.x + dx * inv * minDist;
    z = t.z + dz * inv * minDist;
  }
  return [x, z];
};

export const shortestAngleDelta = (target: number, current: number): number => {
  let d = target - current;
  while (d > Math.PI) d -= 2 * Math.PI;
  while (d < -Math.PI) d += 2 * Math.PI;
  return d;
};
